import { EventDef } from '../types';

/**
 * 事件池（随机事件 · 定稿重写）
 * 每支可安排的训练/工作/休息行程均有事件挂载（休息档 · 在家休息 3 条：新人期 1 条 rank≤2 / 成名后 2 条 rank≥3；SPA、度假各 1 条），
 * 试镜周 3 条（refId='AUDITION'）、签约拍摄周 3 条（'SCRIPT_*' 前缀通配，45 批补），共 50 条。
 * 触发：每执行一周行程后判定，仅当周行程匹配 triggerSchedule 时以 triggerProbability 概率触发。
 * 45 批起事件可带 `gates`（通用条件闸门，见 types.ts Gate / GateSystem）：先过闸门再掷概率。
 *   已挂：宅家成名两条 `rank≥3`（Lv.3 以下无人认识你，「电视上那个明星」类文案穿帮）、新人期一条 `rank≤2`。
 *
 * 选项只用 direct（直接型，必生效）与 check（判定型，属性值 + D6×10 ≥ DC → 成功）两型；
 * tag 型留给后续天赋联动，本表不用。
 * 判定型选项失败时显示 failText 并应用 `failEffects`（批3-B 加重档：单项属性 -3 / 消费型固定扣钱 / 口碑 -2~-5）；
 * 纯错过机会的失败可不填 failEffects（维持失败无效果）。
 *
 * 注：effects / failEffects 合法键：可训练属性（含 wisdom/artistry）+ reputation + money + fame。
 */
export const EVENTS: EventDef[] = [
    // ===== 训练事件（21 条） =====

    {
        id: 'EVENT_TR_CHARM_1',
        title: '柜姐的推销',
        description: '训练间隙逛商场补水乳，柜姐围上来夸你肤质好，力推一整套贵妇护理疗程。',
        triggerSchedule: ['SCHEDULE_COURSE_CHARM_1'],
        triggerProbability: 0.10,
        choices: [
            {
                type: 'check',
                id: 'EVENT_TR_CHARM_1_A',
                text: '听建议体验疗程',
                bindAttr: 'charm',
                dc: 30,
                successText: '肤质肉眼可见地变好了。',
                failText: '除了贵，没别的感受。',
                effects: { charm: 2 },
                failEffects: { money: -3000 },
            },
            {
                type: 'direct',
                id: 'EVENT_TR_CHARM_1_B',
                text: '礼貌婉拒，只买基础款',
                resultText: '作息规律下来，皮肤反而稳了。',
                effects: { charm: 1 },
            },
        ],
    },
    {
        id: 'EVENT_TR_CHARM_2',
        title: '约拍邀请',
        description: '造型课的摄影助教觉得你镜头感出众，想约你拍一组免费创作写真，之后投稿杂志。',
        triggerSchedule: ['SCHEDULE_COURSE_CHARM_2'],
        triggerProbability: 0.10,
        choices: [
            {
                type: 'check',
                id: 'EVENT_TR_CHARM_2_A',
                text: '答应拍摄',
                bindAttr: 'charm',
                dc: 40,
                successText: '成片被杂志编辑看中，配文刊出。',
                failText: '片子平庸，只当练习。',
                effects: { fame: 8, charm: 1 },
                failEffects: { stamina: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_TR_CHARM_2_B',
                text: '婉拒，专注课程',
                resultText: '学会说不，也是一种修养。',
                effects: { eq: 1 },
            },
        ],
    },
    {
        id: 'EVENT_TR_CHARM_3',
        title: '品牌试衣间',
        description: '某高定品牌公关邀你试穿下一季样衣，并为官方账号拍摄宣传照。',
        triggerSchedule: ['SCHEDULE_COURSE_CHARM_3'],
        triggerProbability: 0.08,
        choices: [
            {
                type: 'check',
                id: 'EVENT_TR_CHARM_3_A',
                text: '大方试穿出镜',
                bindAttr: 'temperament',
                dc: 50,
                successText: '品牌转发通稿，你在圈层里刷了脸。',
                failText: '照片没过品牌审稿，石沉大海。',
                effects: { fame: 15, reputation: 1 },
                failEffects: { reputation: -2 },
            },
            {
                type: 'direct',
                id: 'EVENT_TR_CHARM_3_B',
                text: '只试衣，不拍照',
                resultText: '造型师夸你身材管理出色。',
                effects: { charm: 2 },
            },
        ],
    },
    {
        id: 'EVENT_TR_TALENT_1',
        title: '配音小样',
        description: '台词老师兼职配音导演，手头缺一段广播剧女声小样，问你有空帮忙录一版吗。',
        triggerSchedule: ['SCHEDULE_COURSE_TALENT_1'],
        triggerProbability: 0.10,
        choices: [
            {
                type: 'check',
                id: 'EVENT_TR_TALENT_1_A',
                text: '接下小样',
                bindAttr: 'talent',
                dc: 30,
                successText: '一遍过，老师转了笔辛苦费，还把你推荐进配音圈子。',
                failText: '反复重录到深夜，勉强交差。',
                effects: { money: 2000, talent: 1 },
                failEffects: { stamina: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_TR_TALENT_1_B',
                text: '婉拒，先练好功',
                resultText: '安安心心上完这周的课。',
                effects: { talent: 1 },
            },
        ],
    },
    {
        id: 'EVENT_TR_TALENT_2',
        title: '入戏太深',
        description: '情绪练习里你彻底代入了角色，收课后仍泪流不止，同学们围过来关心。',
        triggerSchedule: ['SCHEDULE_COURSE_TALENT_2'],
        triggerProbability: 0.12,
        choices: [
            {
                type: 'check',
                id: 'EVENT_TR_TALENT_2_A',
                text: '向大家讲出感受',
                bindAttr: 'eq',
                dc: 35,
                successText: '情绪得到疏解，你对角色的理解更深了一层。',
                failText: '大家手足无措，你自己缓了一晚才平复。',
                effects: { talent: 2 },
                failEffects: { stamina: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_TR_TALENT_2_B',
                text: '独自留下来复盘情绪',
                resultText: '把角色笔记又写厚了几页。',
                effects: { talent: 1 },
            },
        ],
    },
    {
        id: 'EVENT_TR_TALENT_3',
        title: '名导旁听',
        description: '一位以调教演员著称的名导来研修班旁听，点名几人做即兴片段，你在其中。',
        triggerSchedule: ['SCHEDULE_COURSE_TALENT_3'],
        triggerProbability: 0.08,
        choices: [
            {
                type: 'check',
                id: 'EVENT_TR_TALENT_3_A',
                text: '全力表现',
                bindAttr: 'talent',
                dc: 55,
                successText: '导演当场让你留下联系方式："下部戏见。"',
                failText: '片段中规中矩，导演没留下评价。',
                effects: { fame: 20, reputation: 1 },
                failEffects: { reputation: -2 },
            },
            {
                type: 'direct',
                id: 'EVENT_TR_TALENT_3_B',
                text: '专心做辅助练习',
                resultText: '悄悄观察导演如何拆解对手戏。',
                effects: { talent: 1 },
            },
        ],
    },
    {
        id: 'EVENT_TR_TEMPERAMENT_1',
        title: '礼仪公司的名片',
        description: '礼仪培训公司主理人来参观，递来名片：他们的高端活动常年缺气质出众的礼仪示范。',
        triggerSchedule: ['SCHEDULE_COURSE_TEMPERAMENT_1'],
        triggerProbability: 0.10,
        choices: [
            {
                type: 'check',
                id: 'EVENT_TR_TEMPERAMENT_1_A',
                text: '留下联系方式',
                bindAttr: 'temperament',
                dc: 30,
                successText: '周末接了一场发布会礼仪，酬劳可观。',
                failText: '对方再没联系过你。',
                effects: { money: 2500 },
            },
            {
                type: 'direct',
                id: 'EVENT_TR_TEMPERAMENT_1_B',
                text: '婉拒，专注学习',
                resultText: '把这周的动作要领又磨了一遍。',
                effects: { temperament: 1 },
            },
        ],
    },
    {
        id: 'EVENT_TR_TEMPERAMENT_2',
        title: '策展人的邀约',
        description: '画展上策展人听你对着一幅画讲了十分钟，提出请你为整个展录制语音导览。',
        triggerSchedule: ['SCHEDULE_COURSE_TEMPERAMENT_2'],
        triggerProbability: 0.10,
        choices: [
            {
                type: 'check',
                id: 'EVENT_TR_TEMPERAMENT_2_A',
                text: '接下导览',
                bindAttr: 'temperament',
                dc: 45,
                successText: '导览上线后广受好评，展方付了酬劳并邀你出席开幕式。',
                failText: '试录的几段没通过，展方换了专业播音。',
                effects: { money: 3000, fame: 5 },
                failEffects: { temperament: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_TR_TEMPERAMENT_2_B',
                text: '纯当观众',
                resultText: '慢慢看完了整场展，心里安静。',
                effects: { eq: 1 },
            },
        ],
    },
    {
        id: 'EVENT_TR_TEMPERAMENT_3',
        title: '街拍抓拍',
        description: '下课路上街拍摄影师拦住你：你走过路口的样子被他抓拍下来，气场惊人，他想买断照片。',
        triggerSchedule: ['SCHEDULE_COURSE_TEMPERAMENT_3'],
        triggerProbability: 0.08,
        choices: [
            {
                type: 'check',
                id: 'EVENT_TR_TEMPERAMENT_3_A',
                text: '坐下来谈授权',
                bindAttr: 'temperament',
                dc: 55,
                successText: '照片署名刊出，你拿到了授权费。',
                failText: '摄影师嫌你开价高，转身走了。',
                effects: { money: 3000, fame: 12 },
                failEffects: { eq: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_TR_TEMPERAMENT_3_B',
                text: '免费送他，只求署名',
                resultText: '照片发出去，评论区都在问你是谁。',
                effects: { fame: 5 },
            },
        ],
    },
    {
        id: 'EVENT_TR_STAMINA_1',
        title: '私教的年卡',
        description: '健身房明星私教盯上了你，说你的底子配他的课能出奇迹，年卡今天办有折扣。',
        triggerSchedule: ['SCHEDULE_COURSE_STAMINA_1'],
        triggerProbability: 0.10,
        choices: [
            {
                type: 'check',
                id: 'EVENT_TR_STAMINA_1_A',
                text: '砍出一个体验价',
                bindAttr: 'eq',
                dc: 30,
                successText: '私教松口给了十节课体验价，练得很值。',
                failText: '没砍动，你礼貌离场。',
                effects: { money: -1500, stamina: 2 },
            },
            {
                type: 'direct',
                id: 'EVENT_TR_STAMINA_1_B',
                text: '咬牙办年卡',
                resultText: '贵，但确实有效。',
                effects: { money: -5000, stamina: 2 },
            },
        ],
    },
    {
        id: 'EVENT_TR_STAMINA_2',
        title: 'MV 编舞的邀请',
        description: '进修班的编舞老师正在给一支 MV 排舞，人手不够，问你能不能来示范位帮忙。',
        triggerSchedule: ['SCHEDULE_COURSE_STAMINA_2'],
        triggerProbability: 0.10,
        choices: [
            {
                type: 'check',
                id: 'EVENT_TR_STAMINA_2_A',
                text: '顶上示范位',
                bindAttr: 'stamina',
                dc: 40,
                successText: '一天跟排下来，老师把你记进了常约名单。',
                failText: '体力跟到一半就晃了，老师换了别人。',
                effects: { money: 3000, stamina: 1 },
                failEffects: { stamina: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_TR_STAMINA_2_B',
                text: '专注自己的课',
                resultText: '把今天的新组合练到不用数拍子。',
                effects: { stamina: 1 },
            },
        ],
    },
    {
        id: 'EVENT_TR_STAMINA_3',
        title: '品牌挑战赛',
        description: '运动品牌在办封闭体能挑战赛，名单上还差一个艺人面孔，品牌方找到了你。',
        triggerSchedule: ['SCHEDULE_COURSE_STAMINA_3'],
        triggerProbability: 0.08,
        choices: [
            {
                type: 'check',
                id: 'EVENT_TR_STAMINA_3_A',
                text: '接受封闭集训',
                bindAttr: 'stamina',
                dc: 55,
                successText: '你扛完全程，品牌方当场表示要合作。',
                failText: '中途退赛，品牌方客套地送了你一套装备。',
                effects: { money: 5000, fame: 15, stamina: 2 },
                failEffects: { stamina: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_TR_STAMINA_3_B',
                text: '只担任开场嘉宾',
                resultText: '走个过场，轻松拿出场费。',
                effects: { money: 2000 },
            },
        ],
    },
    {
        id: 'EVENT_TR_EQ_1',
        title: '开放麦之夜',
        description: '训练班搞即兴开放麦，主持人一眼点中你上台，台下坐着全班同学。',
        triggerSchedule: ['SCHEDULE_COURSE_EQ_1'],
        triggerProbability: 0.10,
        choices: [
            {
                type: 'check',
                id: 'EVENT_TR_EQ_1_A',
                text: '硬着头皮上台',
                bindAttr: 'eq',
                dc: 30,
                successText: '一段即兴把全班逗笑，掌声很真。',
                failText: '卡壳半分钟，你在笑声里鞠躬下台。',
                effects: { eq: 2, reputation: 1 },
                failEffects: { eq: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_TR_EQ_1_B',
                text: '在台下记笔记',
                resultText: '看别人怎么接梗，也是学习。',
                effects: { eq: 1 },
            },
        ],
    },
    {
        id: 'EVENT_TR_EQ_2',
        title: '刁钻记者模拟',
        description: '公关课请来真记者客串"刁难官"，模拟发布会被逼问的名场面，你被点名上台。',
        triggerSchedule: ['SCHEDULE_COURSE_EQ_2'],
        triggerProbability: 0.10,
        choices: [
            {
                type: 'check',
                id: 'EVENT_TR_EQ_2_A',
                text: '接招',
                bindAttr: 'eq',
                dc: 45,
                successText: '你四两拨千斤，连记者本人都鼓了掌。',
                failText: '被问得语塞，老师替你解了围。',
                effects: { eq: 2, reputation: 2 },
                failEffects: { temperament: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_TR_EQ_2_B',
                text: '申请做观察员',
                resultText: '记满了三页应对笔记。',
                effects: { eq: 1 },
            },
        ],
    },
    {
        id: 'EVENT_TR_EQ_3',
        title: '救火求助',
        description: '一位小艺人的团队半夜联系你的危机公关课顾问，想付费咨询一桩舆论风波的处理方案。',
        triggerSchedule: ['SCHEDULE_COURSE_EQ_3'],
        triggerProbability: 0.08,
        choices: [
            {
                type: 'check',
                id: 'EVENT_TR_EQ_3_A',
                text: '免费出手，只求交情',
                bindAttr: 'eq',
                dc: 55,
                successText: '方案被全盘采纳，对方团队欠下你一个人情。',
                failText: '方案没被采纳，对方客气地结束了通话。',
                effects: { eq: 2, fame: 10 },
                failEffects: { reputation: -2 },
            },
            {
                type: 'direct',
                id: 'EVENT_TR_EQ_3_B',
                text: '推荐老师出手',
                resultText: '顾问接单成功，分了你一笔介绍费。',
                effects: { money: 3000 },
            },
        ],
    },
    {
        id: 'EVENT_TR_SPECIAL_MARTIAL',
        title: '摔法加练',
        description: '武术指导看你动作干净利落，破例留堂半小时，亲自喂招教你受身摔法。',
        triggerSchedule: ['SCHEDULE_COURSE_SPECIAL_MARTIAL'],
        triggerProbability: 0.12,
        choices: [
            {
                type: 'check',
                id: 'EVENT_TR_SPECIAL_MARTIAL_A',
                text: '咬牙加练',
                bindAttr: 'stamina',
                dc: 40,
                successText: '反复摔了二十次，你学会了卸力。',
                failText: '摔得浑身淤青，指导让你今天到此为止。',
                effects: { stamina: 2, talent: 1 },
                failEffects: { stamina: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_TR_SPECIAL_MARTIAL_B',
                text: '按时收工',
                resultText: '回宿舍泡了个热水澡。',
                effects: { stamina: 1 },
            },
        ],
    },
    // 2026-10-30 特训重做改挂：原挂 SCHEDULE_COURSE_SPECIAL_VARIETY（已删），综艺主持向语义贴合新主持特训
    {
        id: 'EVENT_TR_SPECIAL_VARIETY',
        title: '选角导演旁听',
        description: '某综艺的选角导演悄悄来旁听主持特训课，点名游戏时点到了你。',
        triggerSchedule: ['SCHEDULE_COURSE_SPECIAL_HOST'],
        triggerProbability: 0.12,
        choices: [
            {
                type: 'check',
                id: 'EVENT_TR_SPECIAL_VARIETY_A',
                text: '放飞表现',
                bindAttr: 'eq',
                dc: 45,
                successText: '导演笑着记下你的名字："下季嘉宾名单见。"',
                failText: '表现中规中矩，导演没印象。',
                effects: { fame: 10, eq: 1 },
            },
            {
                type: 'direct',
                id: 'EVENT_TR_SPECIAL_VARIETY_B',
                text: '专注训练不回应',
                resultText: '这节课的内容都吃透了。',
                effects: { eq: 1 },
            },
        ],
    },
    // 2026-10-30 特训重做删除 EVENT_TR_SPECIAL_ADACT（隔壁的广告组）：广告演技特训已删，
    // 新三项特训（主持/唱跳/武打）均无广告向语义，无改挂点——广告向成长回归基础训练。
    // 改挂：原挂 SCHEDULE_COURSE_SPECIAL_STAGE（已删），领舞语义贴合新唱跳特训（检定属性同步 temperament 改 artistry）
    {
        id: 'EVENT_TR_SPECIAL_STAGE',
        title: '快闪领舞',
        description: '商场周年庆的快闪活动临时缺一名领舞，要求"节奏感好、能压住场面"，制作方找到了训练班。',
        triggerSchedule: ['SCHEDULE_COURSE_SPECIAL_SINGDANCE'],
        triggerProbability: 0.12,
        choices: [
            {
                type: 'check',
                id: 'EVENT_TR_SPECIAL_STAGE_A',
                text: '顶上领舞',
                bindAttr: 'artistry',
                dc: 40,
                successText: '路人视频被传开，评论区都在问你是谁。',
                failText: '节奏卡了两次，舞段缩水成了站位。',
                effects: { money: 2500, fame: 5 },
                failEffects: { stamina: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_TR_SPECIAL_STAGE_B',
                text: '专注形体课',
                resultText: '把呼吸和动作的配合又顺了一遍。',
                effects: { stamina: 1 },
            },
        ],
    },
    // 2026-10-30 特训重做改挂：原挂 SCHEDULE_COURSE_SPECIAL_INTERVIEW（已删），访谈接梗语义贴合新主持特训
    {
        id: 'EVENT_TR_SPECIAL_INTERVIEW',
        title: '电台嘉宾',
        description: '电台访谈节目的嘉宾临时放鸽子，经纪人问你要不要顶一晚，"聊聊天而已"。',
        triggerSchedule: ['SCHEDULE_COURSE_SPECIAL_HOST'],
        triggerProbability: 0.12,
        choices: [
            {
                type: 'check',
                id: 'EVENT_TR_SPECIAL_INTERVIEW_A',
                text: '接下直播间',
                bindAttr: 'eq',
                dc: 45,
                successText: '你接梗自然，主持人当场邀你常驻。',
                failText: '一句玩笑被剪成段子在网上流传。',
                effects: { fame: 8, reputation: 1 },
                failEffects: { eq: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_TR_SPECIAL_INTERVIEW_B',
                text: '先观摩一期',
                resultText: '记下了主持人抛话的套路。',
                effects: { talent: 1 },
            },
        ],
    },
    // 2026-10-30 特训重做删除 EVENT_TR_SPECIAL_STYLE（Lookbook 出镜）：风格塑造特训已删且不补
    // （纯形象成长回归基础训练，无 tag 出口），穿搭出镜语义与主持/唱跳/武打均不贴合，无改挂点。

    // ===== 工作事件（10 条） =====
    {
        id: 'EVENT_WK_PHOTO',
        title: '摄影师的私单',
        description: '收工时摄影师私下问你：他手上有个付费写真企划，缺一个有辨识度的模特。',
        triggerSchedule: ['SCHEDULE_WORK_PHOTO'],
        triggerProbability: 0.10,
        choices: [
            {
                type: 'check',
                id: 'EVENT_WK_PHOTO_A',
                text: '答应并谈清条款',
                bindAttr: 'eq',
                dc: 35,
                successText: '合作顺利，成片双方都满意。',
                failText: '条款没谈拢，不了了之。',
                effects: { money: 3000, charm: 1 },
            },
            {
                type: 'direct',
                id: 'EVENT_WK_PHOTO_B',
                text: '婉拒',
                resultText: '专注本职通告。',
                effects: { charm: 1 },
            },
        ],
    },
    {
        id: 'EVENT_WK_MAGAZINE',
        title: '断章取义',
        description: '采访刊出后你发现，自己一句玩笑话被做成了标题，评论区开始跑偏。',
        triggerSchedule: ['SCHEDULE_WORK_MAGAZINE'],
        triggerProbability: 0.10,
        choices: [
            {
                type: 'check',
                id: 'EVENT_WK_MAGAZINE_A',
                text: '亲自下场回应',
                bindAttr: 'eq',
                dc: 45,
                successText: '一条坦荡又幽默的回复扭转风评，转发破万。',
                failText: '回应被二次解读，评论区更热闹了。',
                effects: { reputation: 2, fame: 5 },
                failEffects: { reputation: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_WK_MAGAZINE_B',
                text: '交由团队澄清',
                resultText: '官方声明压下了话题。',
                effects: { reputation: 1 },
            },
        ],
    },
    {
        id: 'EVENT_WK_DANCE',
        title: '领舞缺席',
        description: '开录前领舞临时缺席，编导扫视全场："谁能顶 C 位？"',
        triggerSchedule: ['SCHEDULE_WORK_DANCE'],
        triggerProbability: 0.10,
        choices: [
            {
                type: 'check',
                id: 'EVENT_WK_DANCE_A',
                text: '举手顶上',
                bindAttr: 'stamina',
                dc: 35,
                successText: '你被镜头带到了好几个特写。',
                failText: '位置是站上去了，但慢了半拍。',
                effects: { fame: 5, stamina: 1 },
                failEffects: { reputation: -2 },
            },
            {
                type: 'direct',
                id: 'EVENT_WK_DANCE_B',
                text: '推荐资深舞伴',
                resultText: '她记你的情，之后排舞总带着你。',
                effects: { reputation: 1, eq: 1 },
            },
        ],
    },
    {
        id: 'EVENT_WK_TOUR',
        title: '围上来的观众',
        description: '路演中场，观众围上来求合影，主办方在旁边不停看表催流程。',
        triggerSchedule: ['SCHEDULE_WORK_TOUR'],
        triggerProbability: 0.10,
        choices: [
            {
                type: 'check',
                id: 'EVENT_WK_TOUR_A',
                text: '挤出两分钟互动',
                bindAttr: 'eq',
                dc: 35,
                successText: '现场气氛推到高点，主办方很满意。',
                failText: '互动超时流程被压缩，主办方皱了眉。',
                effects: { reputation: 1, fame: 5 },
                failEffects: { eq: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_WK_TOUR_B',
                text: '按流程收工',
                resultText: '专业、准时，挑不出错。',
                effects: { eq: 1 },
            },
        ],
    },
    {
        id: 'EVENT_WK_LIVESTREAM',
        title: '黑粉刷屏',
        description: '直播间涌进一批恶意弹幕，刷屏质疑你的产品讲解，气氛开始不对。',
        triggerSchedule: ['SCHEDULE_WORK_LIVESTREAM'],
        triggerProbability: 0.10,
        choices: [
            {
                type: 'check',
                id: 'EVENT_WK_LIVESTREAM_A',
                text: '高情商回应',
                bindAttr: 'eq',
                dc: 45,
                successText: '一段真诚又幽默的回应被剪成切片，直播间反而涌进更多人。',
                failText: '你黑着脸提前下播，销量停在半山腰。',
                effects: { fame: 5, reputation: 1 },
                failEffects: { reputation: -4 },
            },
            {
                type: 'direct',
                id: 'EVENT_WK_LIVESTREAM_B',
                text: '无视，继续讲解',
                resultText: '稳住节奏把货带完。',
                effects: { eq: 1 },
            },
        ],
    },
    {
        id: 'EVENT_WK_BRANDLIVE',
        title: '服务器崩了',
        description: '开播半小时，同时在线人数冲破品牌方预期，服务器卡顿，弹幕疯狂滚动。',
        triggerSchedule: ['SCHEDULE_WORK_BRANDLIVE'],
        triggerProbability: 0.10,
        choices: [
            {
                type: 'check',
                id: 'EVENT_WK_BRANDLIVE_A',
                text: '稳住直播间',
                bindAttr: 'eq',
                dc: 50,
                successText: '你临场安排抽奖救场，数据最终翻倍，品牌方当场承诺下一场。',
                failText: '直播中断十几分钟，销量折损大半。',
                effects: { money: 8000, fame: 5 },
                failEffects: { reputation: -5 },
            },
            {
                type: 'direct',
                id: 'EVENT_WK_BRANDLIVE_B',
                text: '让技术紧急扩容',
                resultText: '稳妥处理，保住基本盘。',
                effects: { money: 5000 },
            },
        ],
    },
    {
        id: 'EVENT_WK_BRAND',
        title: '混乱的代拍',
        description: '站台现场代拍蜂拥推挤，围栏眼看要倒，主办方乱成一团。',
        triggerSchedule: ['SCHEDULE_WORK_BRAND'],
        triggerProbability: 0.08,
        choices: [
            {
                type: 'check',
                id: 'EVENT_WK_BRAND_A',
                text: '从容控场',
                bindAttr: 'temperament',
                dc: 50,
                successText: '你一句话让现场安静下来，品牌高层全程看在眼里。',
                failText: '场面失控，你在保镖护送下提前离场。',
                effects: { fame: 5, reputation: 2 },
                failEffects: { reputation: -2 },
            },
            {
                type: 'direct',
                id: 'EVENT_WK_BRAND_B',
                text: '提前结束行程',
                resultText: '品牌方表示理解，尾款照付。',
                effects: { money: 5000 },
            },
        ],
    },
    {
        id: 'EVENT_WK_PRINCIPAL',
        title: '首演夜的失误',
        description: '首演夜的高潮托举，男伴脱手了半拍——你悬在半空的三秒里，全场心都提到了嗓子眼。',
        triggerSchedule: ['SCHEDULE_WORK_PRINCIPAL'],
        triggerProbability: 0.10,
        choices: [
            {
                type: 'check',
                id: 'EVENT_WK_PRINCIPAL_A',
                text: '空中稳住落回节奏',
                bindAttr: 'stamina',
                dc: 50,
                successText: '你硬是用一个即兴旋转接住了失误，落地时掌声比原编排还响。',
                failText: '你重重摔在台面，坚持完成了后半场，谢幕时全场起立——掌声里一半是敬意，一半是叹息。',
                effects: { fame: 5, stamina: 2 },
                failEffects: { reputation: -2 },
            },
            {
                type: 'direct',
                id: 'EVENT_WK_PRINCIPAL_B',
                text: '坚持完成演出',
                resultText: '带伤跳完，第二天舞评夸了你的"职业精神"，只是约了三个月的康复课。',
                effects: { stamina: 1 },
            },
        ],
    },
    {
        id: 'EVENT_WK_THEATER',
        title: '侧幕的等待',
        description: '排练季第 40 天，你仍在侧幕候场。女主角经过时低声说："今天我嗓子不太行。"',
        triggerSchedule: ['SCHEDULE_WORK_THEATER'],
        triggerProbability: 0.10,
        choices: [
            {
                type: 'check',
                id: 'EVENT_WK_THEATER_A',
                text: '默默把全场地板再擦一遍',
                bindAttr: 'talent',
                dc: 35,
                successText: '她记住了你的话，三天后的下午场，她在台上咳血般的坚持换来你侧幕的一个眼神——"看好了，学着点。"',
                failText: '地板擦得反光，没人看你一眼。',
                effects: { talent: 2 },
                failEffects: { stamina: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_WK_THEATER_B',
                text: '安静候场背词',
                resultText: '台词本翻烂了第三本。',
                effects: { talent: 1 },
            },
        ],
    },
    {
        id: 'EVENT_WK_LEADACT',
        title: '救场之夜',
        description: '开场前半小时，男主角急性失声，制作人冲进后台："全组只有你熟他的戏——今晚，你上不上？"',
        triggerSchedule: ['SCHEDULE_WORK_LEADACT'],
        triggerProbability: 0.10,
        choices: [
            {
                type: 'check',
                id: 'EVENT_WK_LEADACT_A',
                text: '顶上去',
                bindAttr: 'talent',
                dc: 50,
                successText: '两小时一次成，谢幕时掌声长达四分钟，第二天剧评标题是"新角惊艳"。',
                failText: '第二幕忘词三秒，台下有人举起了手机。',
                effects: { talent: 2, reputation: 2 },
                failEffects: { reputation: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_WK_LEADACT_B',
                text: '婉拒救场',
                resultText: '你在侧幕看完一整场，笔记本又厚了几页。',
                effects: { talent: 1 },
            },
        ],
    },

    // ===== 智识系训练事件 =====
    {
        id: 'EVENT_TR_WISDOM_1',
        title: '围读会的争论',
        description: '围读会上你和另一位演员对角色动机的理解完全相反，谁也说服不了谁，全场停下来等你俩掰扯。',
        triggerSchedule: ['SCHEDULE_COURSE_WISDOM_1'],
        triggerProbability: 0.10,
        choices: [
            {
                type: 'check',
                id: 'EVENT_TR_WISDOM_1_A',
                text: '逐场拆解剧本逻辑',
                bindAttr: 'wisdom',
                dc: 30,
                successText: '你的拆解环环相扣，连编剧都掏出笔记本来记。',
                failText: '越争越乱，老师各打五十大板收场。',
                effects: { wisdom: 2 },
                failEffects: { temperament: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_TR_WISDOM_1_B',
                text: '会后单独请教编剧',
                resultText: '编剧私下讲了他真正想表达的东西，你听得入神。',
                effects: { wisdom: 1 },
            },
        ],
    },
    {
        id: 'EVENT_TR_WISDOM_2',
        title: '即兴心理访谈',
        description: '心理顾问课玩"角色心理访谈"：你的角色被同学连环追问童年与创伤，全程不许出戏。',
        triggerSchedule: ['SCHEDULE_COURSE_WISDOM_2'],
        triggerProbability: 0.10,
        choices: [
            {
                type: 'check',
                id: 'EVENT_TR_WISDOM_2_A',
                text: '以角色身份应答',
                bindAttr: 'wisdom',
                dc: 40,
                successText: '你滴水不漏地答完，顾问评价"人格连贯度罕见"。',
                failText: '一个追问让你卡壳笑场，仓皇出戏。',
                effects: { wisdom: 2, talent: 1 },
                failEffects: { wisdom: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_TR_WISDOM_2_B',
                text: '退到一旁做记录',
                resultText: '看别人怎么被问穿，笔记记了满满几页。',
                effects: { wisdom: 1 },
            },
        ],
    },
    {
        id: 'EVENT_TR_WISDOM_3',
        title: '原著圆桌',
        description: '一部文学名著要影视化，制片方办读者圆桌会，邀你作为艺人代表出席，台下坐满书粉。',
        triggerSchedule: ['SCHEDULE_COURSE_WISDOM_3'],
        triggerProbability: 0.08,
        choices: [
            {
                type: 'check',
                id: 'EVENT_TR_WISDOM_3_A',
                text: '发表改编见解',
                bindAttr: 'wisdom',
                dc: 50,
                successText: '你的发言被整理成通稿传播，书粉圈开始对你产生好感。',
                failText: '一句外行话被剪出来传播，书粉不买账。',
                effects: { fame: 8, reputation: 1 },
                failEffects: { reputation: -2 },
            },
            {
                type: 'direct',
                id: 'EVENT_TR_WISDOM_3_B',
                text: '只听不说',
                resultText: '记满了各方观点，散场时若有所思。',
                effects: { wisdom: 1 },
            },
        ],
    },

    // ===== 才艺系训练事件 =====
    {
        id: 'EVENT_TR_ARTISTRY_1',
        title: '高音的坎',
        description: '声乐老师说那个高音你总差半口气，今天必须翻过去——全教室的同期都在等你。',
        triggerSchedule: ['SCHEDULE_COURSE_ARTISTRY_1'],
        triggerProbability: 0.10,
        choices: [
            {
                type: 'check',
                id: 'EVENT_TR_ARTISTRY_1_A',
                text: '一遍遍冲过去',
                bindAttr: 'artistry',
                dc: 30,
                successText: '破音七次之后终于唱上去了，老师带头给你鼓掌。',
                failText: '嗓子唱哑了也没过去，老师勒令你休息一周护嗓。',
                effects: { artistry: 2 },
                failEffects: { stamina: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_TR_ARTISTRY_1_B',
                text: '先回头练气息',
                resultText: '高音还在，但气息基础扎实了很多。',
                effects: { artistry: 1 },
            },
        ],
    },
    {
        id: 'EVENT_TR_ARTISTRY_2',
        title: '琴行代课',
        description: '琴行老板听完你练琴，问你愿不愿意周末来代课，时薪可观，先试讲一节。',
        triggerSchedule: ['SCHEDULE_COURSE_ARTISTRY_2'],
        triggerProbability: 0.10,
        choices: [
            {
                type: 'check',
                id: 'EVENT_TR_ARTISTRY_2_A',
                text: '接下试讲',
                bindAttr: 'artistry',
                dc: 40,
                successText: '示范干净利落，学生家长当场满意，老板排了你的长期课表。',
                failText: '你会弹不会讲，一节课上得磕磕绊绊，老板婉言作罢。',
                effects: { money: 2500, artistry: 1 },
                failEffects: { eq: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_TR_ARTISTRY_2_B',
                text: '婉拒代课',
                resultText: '安心练自己的曲子，今天进步不小。',
                effects: { artistry: 1 },
            },
        ],
    },
    {
        id: 'EVENT_TR_ARTISTRY_3',
        title: '临时改编',
        description: '综艺彩排突发状况：伴舞团队缺席，导演要求你把唱跳快歌两小时内改成纯唱慢版上台。',
        triggerSchedule: ['SCHEDULE_COURSE_ARTISTRY_3'],
        triggerProbability: 0.08,
        choices: [
            {
                type: 'check',
                id: 'EVENT_TR_ARTISTRY_3_A',
                text: '现场重新编曲',
                bindAttr: 'artistry',
                dc: 50,
                successText: '慢版意外动人，导演当场拍板以后就用这版。',
                failText: '改编生硬，最后还是用回了原版伴奏带救场。',
                effects: { fame: 10, artistry: 1 },
                failEffects: { artistry: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_TR_ARTISTRY_3_B',
                text: '坚持原版照常上台',
                resultText: '完成度很高，零失误收场。',
                effects: { stamina: 1 },
            },
        ],
    },

    // ===== 音乐路径工作事件 =====
    {
        id: 'EVENT_WK_GIG',
        title: '醉客点歌',
        description: '一桌喝高的客人起哄点了一首你完全不擅长的老歌，还把小费拍在了桌上。',
        triggerSchedule: ['SCHEDULE_WORK_GIG'],
        triggerProbability: 0.10,
        choices: [
            {
                type: 'check',
                id: 'EVENT_WK_GIG_A',
                text: '改编成自己的风格唱',
                bindAttr: 'artistry',
                dc: 35,
                successText: '跑调的地方被你唱成了"个人风格"，全场起哄叫好。',
                failText: '唱到一半接不上气，在哄笑声中尴尬收场。',
                effects: { money: 500, artistry: 1 },
                failEffects: { temperament: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_WK_GIG_B',
                text: '礼貌换一首擅长的',
                resultText: '客人扫兴，但老板替你打了圆场。',
                effects: { eq: 1 },
            },
        ],
    },
    {
        id: 'EVENT_WK_FESTIVAL',
        title: '雨中救场',
        description: '音乐节开场前突降大雨，你的伴奏设备进水保护，上台时间已到，台下人潮开始骚动。',
        triggerSchedule: ['SCHEDULE_WORK_FESTIVAL'],
        triggerProbability: 0.08,
        choices: [
            {
                type: 'check',
                id: 'EVENT_WK_FESTIVAL_A',
                text: '雨中清唱救场',
                bindAttr: 'artistry',
                dc: 50,
                successText: '一段雨中清唱成了全场名场面，短视频疯传一夜破圈。',
                failText: '勉强用了备用设备，中途两次炸音，表演支离破碎。',
                effects: { fame: 10, reputation: 1 },
                failEffects: { reputation: -2 },
            },
            {
                type: 'direct',
                id: 'EVENT_WK_FESTIVAL_B',
                text: '等雨停再上台',
                resultText: '时长被压缩，但顺利完成，主办方记了你的配合。',
                effects: { eq: 1 },
            },
        ],
    },

    // ===== 休息事件（4 条 · 补 SCHEDULE_REST_* 三档零覆盖） =====

    {
        id: 'EVENT_REST_HOME_1',
        title: '凌晨的炸鸡单',
        description: '连轴转了半个月，你在休息日半夜没忍住点了份炸鸡。开门交接时，外卖小哥愣了一下：「……你是电视上那个明星吗？」',
        triggerSchedule: ['SCHEDULE_REST_1'],
        triggerProbability: 0.10,
        gates: [{ type: 'rank', min: 3 }],   // 45 批：「电视上那个明星」以有知名度为前提（用户改口径 2→3）
        choices: [
            {
                type: 'check',
                id: 'EVENT_REST_HOME_1_A',
                text: '笑着承认，聊两句',
                bindAttr: 'eq',
                dc: 30,
                successText: '他激动地给站长发了语音，从此你的订单永远被排在最顺路的一单，还附赠一根小酥肉。',
                failText: '他认出你之后紧张得语无伦次，评价里写了一百多字，标点全用错。你盯着屏幕替他尴尬。',
                effects: { eq: 1 },
                failEffects: { temperament: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_REST_HOME_1_B',
                text: '「送错了，我家没有这个人」',
                resultText: '你关上房门，把炸鸡分给赶回来取错单的另一个骑手。深夜的楼道里，三个人蹲着笑到肚子疼。',
                effects: { stamina: 1 },
            },
        ],
    },
    {
        id: 'EVENT_REST_HOME_2',
        title: '妈妈的视频通话',
        description: '休息日的下午，妈妈发来视频邀请，接通后第一句是「怎么瘦了」，第二句是转发链接——《这几种食物千万别吃》。',
        triggerSchedule: ['SCHEDULE_REST_1'],
        triggerProbability: 0.10,
        gates: [{ type: 'rank', min: 3 }],   // 45 批：「妈在网上看到你了」以有知名度为前提（用户改口径 2→3）
        choices: [
            {
                type: 'check',
                id: 'EVENT_REST_HOME_2_A',
                text: '认真聊够一个小时',
                bindAttr: 'wisdom',
                dc: 35,
                successText: '你跟她讲了工作的琐碎和喜欢，她似懂非懂，但挂电话前说：「闺女，妈在网上看到你了。」',
                failText: '聊到第十分钟又开始催你回家考编制，你借口剧组找茬挂了线。赢了话题，输了心情。',
                effects: { eq: 1, wisdom: 1 },
                failEffects: { temperament: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_REST_HOME_2_B',
                text: '乖乖听完养生科普',
                resultText: '你把那篇《千万别吃》转发给了经纪人。她回你一个颤抖的拳头表情。',
                effects: { reputation: 1 },
            },
        ],
    },
    {
        id: 'EVENT_REST_HOME_3',
        title: '出租屋的水管',
        description: '休息日你想把出租屋的洗晒一次搞定，结果扫地机器人上了沙发、沙发套进了洗衣机。浴室水管还在滴水，物业大姐敲门：「姑娘，你屋里没事吧？」',
        triggerSchedule: ['SCHEDULE_REST_1'],
        triggerProbability: 0.12,
        gates: [{ type: 'rank', max: 2 }],   // 45 批：新人期专属——还没人认识你，日子是自己过的
        choices: [
            {
                type: 'check',
                id: 'EVENT_REST_HOME_3_A',
                text: '稳住，自己修',
                bindAttr: 'wisdom',
                dc: 30,
                successText: '你举着手机查阀门图纸，四十分钟把水管伺候停了。大姐验收时嘀咕：「402 这姑娘，过日子是把式。」',
                failText: '修成了大修。水漫过踢脚线的半小时里，你第一次认真考虑回老家考编制这件事。',
                effects: { wisdom: 1 },
                failEffects: { stamina: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_REST_HOME_3_B',
                text: '楼栋群里求助',
                resultText: '群里搞装修的大哥拎着扳手上来，十分钟收工，只留下一句：「下次别硬撑。」你把沙发套晾回绳上，觉得这楼比剧组暖。',
                effects: { eq: 1 },
            },
        ],
    },
    {
        id: 'EVENT_REST_SPA_1',
        title: '手法',
        description: 'SPA 师按到你肩胛时突然沉默了两秒，隔着帘子压低声音：「姐，别动，我这手法第一次碰到这么硬的筋，我叫我们老师来。」你听见外面小跑进来三个人的脚步声。',
        triggerSchedule: ['SCHEDULE_REST_2'],
        triggerProbability: 0.10,
        choices: [
            {
                type: 'check',
                id: 'EVENT_REST_SPA_1_A',
                text: '一声不吭扛完三分钟',
                bindAttr: 'stamina',
                dc: 30,
                successText: '领头的老师亲自把你送到门口：「姐这忍痛度，拍什么打戏都够用。」一个月后，听说了这件事的武指真的来找你了。',
                failText: '你中途惨叫了一声，全店都听见了。第二天店里挂出了「隔音改造中」的告示。',
                effects: { stamina: 2, fame: 5 },
                failEffects: { reputation: -2 },
            },
            {
                type: 'direct',
                id: 'EVENT_REST_SPA_1_B',
                text: '边扛边和老师聊开了',
                resultText: '你从护肤聊到出差落地包，聊到老师孩子上几年级。结束前台记住了你的偏好：「演出前不送姜茶。」这家店从此成了你的秘密基地。',
                effects: { eq: 1 },
            },
        ],
    },
    {
        id: 'EVENT_REST_VACATION_1',
        title: '海边的写生摊',
        description: '度假的海滩上，有个写生摊把你画进了背景里。画里的你提着鞋走在浪线边，摊主是个美院学生，正低头调颜料，浑然不觉原型站在面前。',
        triggerSchedule: ['SCHEDULE_REST_3'],
        triggerProbability: 0.10,
        choices: [
            {
                type: 'check',
                id: 'EVENT_REST_VACATION_1_A',
                text: '买下这幅画，请他签个名',
                bindAttr: 'artistry',
                dc: 30,
                successText: '他认出你的那一刻比你还紧张。后来这幅画挂在剧组休息室里，人人问那是哪里。',
                failText: '你亮明身份后他只剩下的点头哈腰，画框落灰，气氛全无。',
                effects: { artistry: 1, wisdom: 1 },
                failEffects: { temperament: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_REST_VACATION_1_B',
                text: '不打扰，在画前合影一张自己收藏',
                resultText: '你付了看画的钱，没留名字。回酒店的路上你想：被当成风景，比被当成明星开心多了。',
                effects: { eq: 1 },
            },
        ],
    },

    // ===== 试镜周事件（3 条 · 45 批补，refId='AUDITION'） =====

    {
        id: 'EVENT_AUD_WAIT_1',
        title: '候场的搭戏',
        description: '候场室安静得像考场，隔壁座位的姑娘一直小声碎碎念台词。忽然她转头看你：「对不起，我紧张——能陪我走一遍戏吗？」',
        triggerSchedule: ['AUDITION'],
        triggerProbability: 0.12,
        choices: [
            {
                type: 'check',
                id: 'EVENT_AUD_WAIT_1_A',
                text: '陪她把整场戏顺完',
                bindAttr: 'eq',
                dc: 30,
                successText: '你们来回过了两遍，她眼睛亮了。出门时她塞给你一颗薄荷糖：「加油，希望我们都能留下。」',
                failText: '她两句就笑场，反倒把你带得心里发毛。剩下半小时你一直在心里默念自己那句废戏。',
                effects: { eq: 1 },
                failEffects: { temperament: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_AUD_WAIT_1_B',
                text: '教她一个自己总结的定神办法',
                resultText: '你教她「看远处三秒再开口」，她试了试，肩膀真的松下来。她被叫进房间前，朝你比了个大拇指。',
                effects: { reputation: 1 },
            },
        ],
    },
    {
        id: 'EVENT_AUD_SCRIPT_1',
        title: '临出门掉的那页纸',
        description: '轮到你前五分钟，文件夹里的自备台词页滑出来散了一地。广播里正在念上一个号码，留给你的时间不到两分钟。',
        triggerSchedule: ['AUDITION'],
        triggerProbability: 0.12,
        choices: [
            {
                type: 'check',
                id: 'EVENT_AUD_SCRIPT_1_A',
                text: '捡起来按顺序速读一遍',
                bindAttr: 'wisdom',
                dc: 35,
                successText: '你把三页纸在三十秒里从「纸」读成了「脑子」。推门进去，导演问角色动机，你答得比稿子上多一层。',
                failText: '纸理顺了，心没理顺。开口第一句你把角色名字说错，全场装作没听见。',
                effects: { talent: 1, wisdom: 1 },
                failEffects: { temperament: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_AUD_SCRIPT_1_B',
                text: '不捡了，空手进考场',
                resultText: '你赌台词早在你身上，把捡纸的工夫留给隔门听上一个考生的发挥——白捡两个新处理。',
                effects: { wisdom: 1 },
            },
        ],
    },
    {
        id: 'EVENT_AUD_IMPROV_1',
        title: '导演的加试题',
        description: '你演完规定片段，导演忽然抬头：「再试试姐姐那个角色？没有你的稿子，就演对峙这场。」',
        triggerSchedule: ['AUDITION'],
        triggerProbability: 0.12,
        choices: [
            {
                type: 'check',
                id: 'EVENT_AUD_IMPROV_1_A',
                text: '当场接下',
                bindAttr: 'talent',
                dc: 35,
                successText: '你借了半口气，开口就是另一个人。选角导演在你走后翻着你的资料问经纪人的名字。',
                failText: '你演到一半开始怀疑自己到底是姐姐还是妹妹。导演善解人意地说：「好了，谢谢。」',
                effects: { talent: 1, reputation: 1 },
                failEffects: { temperament: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_AUD_IMPROV_1_B',
                text: '坦白没准备',
                resultText: '你笑着承认只准备了一个角色。导演反而点头：「诚实也是本事。行，就你的角色了。」',
                effects: { reputation: 1 },
            },
        ],
    },

    // ===== 签约拍摄周事件（3 条 · 45 批补，triggerSchedule='SCRIPT_*' 前缀通配） =====

    {
        id: 'EVENT_FILM_NIGHT_1',
        title: '通告单前一晚',
        description: '凌晨四点，明天有大段情绪独戏，你从床上惊坐起来——那段戏还没背进肌肉里。房间的水壶在召唤你。',
        triggerSchedule: ['SCRIPT_*'],
        triggerProbability: 0.12,
        choices: [
            {
                type: 'check',
                id: 'EVENT_FILM_NIGHT_1_A',
                text: '起来泡浓茶过词',
                bindAttr: 'stamina',
                dc: 30,
                successText: '天亮时那段独白从「会背」变成「长在嘴上」。现场你一条过，导演把夸奖留给了摄影机的走位。',
                failText: '浓茶没赢过褪黑素，你边背边睡。现场第一句就卡壳，对手演员替你接了个全新的处理。',
                effects: { talent: 1 },
                failEffects: { stamina: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_FILM_NIGHT_1_B',
                text: '倒头就睡，信直觉',
                resultText: '你睡足七小时。现场你给了和背稿时不一样的选择，导演说这是他这周看到最好的一条。',
                effects: { wisdom: 1 },
            },
        ],
    },
    {
        id: 'EVENT_FILM_WATER_1',
        title: '泼水的那场戏',
        description: '剧情需要你被浇一桶冷水。场务怯生生看你，导演还没喊开拍，你看见他装满了三桶——这镜头要拍好几遍机位。',
        triggerSchedule: ['SCRIPT_*'],
        triggerProbability: 0.12,
        choices: [
            {
                type: 'check',
                id: 'EVENT_FILM_WATER_1_A',
                text: '一声不吭连泡到底',
                bindAttr: 'temperament',
                dc: 35,
                successText: '你从头到尾没皱眉。花絮照里你的湿头发丝都摆得服帖，收工全组排队给你鼓掌。',
                failText: '第三遍你鼻子一酸，回头特写时打了个喷嚏。导演说：「很可爱，但不对年代。」',
                effects: { reputation: 1, talent: 1 },
                failEffects: { charm: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_FILM_WATER_1_B',
                text: '请道具换温水',
                resultText: '道具师跟摄影一合计：温水在冷场里冒出的雾气反而添了氛围。戏照拍，人人开心。',
                effects: { wisdom: 1 },
            },
        ],
    },
    {
        id: 'EVENT_FILM_BDAY_1',
        title: '对手戏的即兴',
        description: '今天那场对峙戏，对手演员突然改了演法——原本安排的沉默对视变成了直接冲你吼。导演没喊停，镜头还转着。',
        triggerSchedule: ['SCRIPT_*'],
        triggerProbability: 0.12,
        choices: [
            {
                type: 'check',
                id: 'EVENT_FILM_BDAY_1_A',
                text: '接住他的情绪即兴回应',
                bindAttr: 'eq',
                dc: 30,
                successText: '你顺着他的怒气把台词推到了剧本没写到的地方。导演喊停后沉默了三秒，说：「这段留。」',
                failText: '你被他的突然爆发打乱了节奏，接了一句万能台词糊弄过去。对手演员拍了拍你的肩，小声说「下次我提前说」。',
                effects: { reputation: 1, eq: 1 },
                failEffects: { temperament: -3 },
            },
            {
                type: 'direct',
                id: 'EVENT_FILM_BDAY_1_B',
                text: '保持原计划不为所动',
                resultText: '你按原定演法走完全程。导演说两个节奏撞在一起反而有了张力，这条比排练时好。',
                effects: { wisdom: 1 },
            },
        ],
    },
];

/** 按 ID 索引 */
export const EVENT_MAP: Record<string, EventDef> = {};
EVENTS.forEach(e => { EVENT_MAP[e.id] = e; });